import { PromotionType } from '@/types/api.generated';

import { SbkBetSlip, SbkPromo } from '../../types';
import { BetIds } from '../betslip-utils';
import { CriteriaState, arePromoCriteriaSatisfied, isPromoVisibleForBet } from './criterion-validators';

export type AutoApplyState = CriteriaState &
    Pick<SbkBetSlip, 'selectedPromos' | 'isBetrBucksEnabled' | 'isAutoPromoDismissed'>;

export const isAutoApplyPromo = (promo: SbkPromo) => promo.type === PromotionType.PlayAndGet;

/** Maps each promo-less, bonus-free bet to the first Play and Get promo whose criteria it satisfies */
export const getPromosToAutoApply = (promos: SbkPromo[], state: AutoApplyState): Record<string, SbkPromo> => {
    if (state.isAutoPromoDismissed) {
        return {};
    }
    const autoApplyPromos = promos.filter(isAutoApplyPromo);
    if (autoApplyPromos.length === 0) {
        return {};
    }
    const selectionIds = Object.keys(state.selections);
    const betIds = selectionIds.length >= 2 ? [...selectionIds, BetIds.COMBO] : selectionIds;
    return betIds.reduce<Record<string, SbkPromo>>((acc, betId) => {
        if (state.selectedPromos[betId] || state.isBetrBucksEnabled[betId]) {
            return acc;
        }
        const promo = autoApplyPromos.find(
            candidate => isPromoVisibleForBet(candidate, betId) && arePromoCriteriaSatisfied(candidate, state, betId)
        );
        if (promo) {
            acc[betId] = promo;
        }
        return acc;
    }, {});
};

export const getStalePromoBetIds = (promos: SbkPromo[], selectedPromos: SbkBetSlip['selectedPromos']) =>
    Object.keys(selectedPromos).filter(betId => {
        const promo = selectedPromos[betId];
        return !!promo && !promos.some(candidate => candidate.campaign_token === promo.campaign_token);
    });
